var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("NewMega", {
    attrs: {
      menu: _vm.menuContent,
      "menu-alignment": "center",
      element: "header",
      handler: "click",
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ item, onClose }) {
          return [
            _c("InnerContent", {
              attrs: { content: item },
              on: { "close-dropdown": onClose },
            }),
          ]
        },
      },
      {
        key: "mobile-icon",
        fn: function (data) {
          return [
            _c(
              "icon-base",
              {
                staticClass: "icon-mobile",
                attrs: { "icon-name": "chevron-right" },
              },
              [_c("icon-chevron-right")],
              1
            ),
          ]
        },
      },
      {
        key: "dropdown-icon",
        fn: function (data) {
          return [
            _c(
              "icon-base",
              {
                staticClass: "icon-dropdown",
                attrs: { "icon-name": "chevron-down" },
              },
              [_c("icon-chevron-down")],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }